import { useState, useEffect, useCallback } from 'react';
import { useAuth } from 'react-oidc-context';
import { useApiFetch } from '../api';
import { ServerNetworkData } from '../types/models/ServerNetwork';

export function useServerNetwork(serverId: number | null) {
  const auth = useAuth();
  const apiFetch = useApiFetch();
  const [data, setData] = useState<ServerNetworkData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchNetwork = useCallback(async () => {
    if (serverId === null || !auth.user?.access_token) return;

    setLoading(true);
    setError(null);

    try {
      const response = await apiFetch(`/datacenters/servers/${serverId}/network`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const json = await response.json();
      if (json.status !== 'success') {
        throw new Error(json.message ?? 'Unexpected response from server');
      }

      setData(json.data as ServerNetworkData);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('An unexpected error occurred'));
    } finally {
      setLoading(false);
    }
  }, [serverId, auth.user?.access_token, apiFetch]);

  useEffect(() => {
    fetchNetwork();
  }, [fetchNetwork]);

  return { data, loading, error, refetch: fetchNetwork };
}
